import type { Reference } from "../Reference.js";
import { referencesPathMap } from "./referencesPathMap.js";

export function getReferenceDetailPath(reference: Reference): string {
	return `${referencesPathMap[reference.locale]}/${reference.urlSlug}`;
}
